import {Col, Row} from 'react-bootstrap'
const CreateScriptBody = ({payload, setPayload}: any) => {
  return (
    <>
      <div className='d-flex justify-content-between w-100 mb-4'>
        <h4 className='text-gray-800 fs-3 fw-bold'>Script Details</h4>
      </div>
      <div className='fixed-height-body'>
        <form>
          <Row className='mt-5 no-gutters noPadding mb-5'>
            <Col sm md lg={6}>
              <label className='d-flex align-items-center mb-2 required'>
                <span className='fs-6 fw-semibold lh-23'>Script Name</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                placeholder='Enter Script Name'
                id='ScriptName'
                name='scriptName'
                value={payload.name}
                onChange={(e) =>
                  setPayload((prev: any) => {
                    return {...prev, name: e.target.value}
                  })
                }
              />
            </Col>
          </Row>
          <label className='fs-6 fw-semibold mb-2'>Script Description</label>
          <textarea
            className='form-control form-control-solid'
            value={payload.scriptDescription}
            onChange={(e) =>
              setPayload((prev: any) => {
                return {...prev, scriptDescription: e.target.value}
              })
            }
            placeholder='Enter Script Description'
            name='details_description'
          ></textarea>

          <button className='btn btn-primary' style={{float: 'right', marginTop: '40px'}}>
            Submit
          </button>
        </form>
      </div>
    </>
  )
}
export default CreateScriptBody
